<div class="card sq-card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['SUBTITLEPROJECTUSERGROUPROLES'] | translate}}</h4>
        <h4>{{this.data.userName}}</h4>
    </div>
    <div class="card-body">
        <div class="user-grouprole-board-body-table">
            <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                    Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
            </div> -->
            <ag-grid-angular style="width:100%;  padding: 5px;" 
            class="ag-theme-balham"            
            [domLayout]="'autoHeight'"
            [gridOptions]="gridOptions" 
            (gridReady)="onGridReady($event)"
            [components]="components">
            </ag-grid-angular>
        </div>
    
        <div class="row button-right">
            <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button  (click)="cancel()">
                <mat-icon>close</mat-icon>
            </button>
            <span style="flex: 1 1 auto"></span> -->
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                (click)="cancel()" >Schließen</button>
            </a>                   
            <!-- <span style="flex: 1 1 auto"></span> -->

        </div>        
    </div>
  
</div>